import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetHomePermissions } from '@ibk/shared-permissioning';
import { Loading } from '@ibk/shared-ui';
export const ClientCenterAccessGuard = ({ children }) => {
    const location = useLocation();
    const { hasClientPortalViewPermission } = useGetHomePermissions();
    const isResolvingAccess = hasClientPortalViewPermission === undefined;
    if (isResolvingAccess)
        return _jsx(Loading, { fullScreen: true });
    const alreadyInHome = location.pathname === '/home' || location.pathname.startsWith('/home/');
    if (!hasClientPortalViewPermission && !alreadyInHome) {
        return _jsx(Navigate, { to: '/home', replace: true });
    }
    return _jsx(_Fragment, { children: children ?? _jsx(Outlet, {}) });
};
